import * as React from 'react';

type TitleLevel = 1 | 2 | 3;

type TitleProps = {
  children: React.ReactNode;
  level?: TitleLevel;
  className?: string;
};

export default function Title({ children, level = 1, className }: TitleProps) {
  const Tag = ('h' + String(level)) as unknown as React.ElementType;

  const baseByLevel: Record<TitleLevel, string> = {
    1: 'text-3xl/[40px] font-semibold',
    2: 'text-[20px]/[24px] font-medium',
    3: 'text-[16px]/[24px] font-normal',
  };

  const classes = className ? `${baseByLevel[level]} ${className}` : baseByLevel[level];

  return <Tag className={classes}>{children}</Tag>;
}
